import { useCallback } from 'react'

import { useTribeClient } from '@tribeplatform/react-sdk'

export const useGetPlaceDetails = () => {
  const { client } = useTribeClient()

  const getPlaceDetails = useCallback(
    async (placeId: string, sessionToken: string) => {
      return client.events.getPlaceDetails({ input: { placeId, sessionToken } })
    },
    [client],
  )

  return {
    getPlaceDetails,
  }
}
